import { render, staticRenderFns } from "./DisableTwoFactorAuth.vue?vue&type=template&id=00741945&scoped=true"
import script from "./DisableTwoFactorAuth.vue?vue&type=script&lang=js"
export * from "./DisableTwoFactorAuth.vue?vue&type=script&lang=js"
import style0 from "./DisableTwoFactorAuth.vue?vue&type=style&index=0&id=00741945&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00741945",
  null
  
)

export default component.exports